/* eslint-disable camelcase */
import AlertTool from '@/molecules/AlertTool';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import { useGetSalesSummary } from 'hooks/queries/marketplace/wallet';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { useCmsData } from 'utils/cms';

const STATUS_TO_VARIANT = {
  error: VARIANT_COLOR_ENUM.ERROR,
  warning: VARIANT_COLOR_ENUM.INFO,
};

export const useGetKYCLimit = () => {
  const { generalSettings } = useCmsData();
  const {
    queryResult: { data, isLoading },
  } = useGetSalesSummary();
  let statusKYCLimit: 'warning' | 'error' | undefined;
  // const maxWarningSaleCount = Number(generalSettings.wallet_antifraud_sales_warning);
  const maxWarningSaleAmount = Number(generalSettings.wallet_antifraud_earnings_warning);
  // const maxErrorSaleCount = Number(generalSettings.wallet_antifraud_sales_error);
  const maxErrorSaleAmount = Number(generalSettings.wallet_antifraud_earnings_error);

  if (data && data.data.totalSalesAmount) {
    if (data.data.totalSalesAmount >= maxWarningSaleAmount) {
      statusKYCLimit = 'warning';
    }
    if (data.data.totalSalesAmount >= maxErrorSaleAmount) {
      statusKYCLimit = 'error';
    }
  }

  return {
    isLoading,
    statusKYCLimit,
    data,
  };
};

export const KYClimitToJSX = () => {
  const {
    generalSettings: { wallet_antifraud_verify_profile_url },
  } = useCmsData();
  const { statusKYCLimit } = useGetKYCLimit();
  const { t } = useTranslation();
  if (statusKYCLimit) {
    return (
      <AlertTool variant={STATUS_TO_VARIANT[statusKYCLimit]}>
        {t(`wallet.antifraud.limits.${statusKYCLimit}.label`)}
        <Link className="underline" href={wallet_antifraud_verify_profile_url}>
          {t('wallet.antifraud.limits.cta')}
        </Link>
      </AlertTool>
    );
  }

  return null;
};
